import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d57ea5b4"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "selected-work",
  class: "work_section",
  "aria-describedby": "my works"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_section_header = _resolveComponent("section-header")!
  const _component_work_items = _resolveComponent("work-items")!
  const _component_work_modal = _resolveComponent("work-modal")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _createVNode(_component_section_header, null, {
      default: _withCtx(() => [
        _createTextVNode("Selected Work")
      ]),
      _: 1
    }),
    _createVNode(_component_work_items, { onUpdateModal: _ctx.updateModal }, null, 8, ["onUpdateModal"]),
    _createVNode(_component_work_modal, {
      onUpdateModal: _ctx.updateModal,
      "is-open": _ctx.isOpen,
      work: _ctx.activeWork
    }, null, 8, ["onUpdateModal", "is-open", "work"])
  ]))
}